export default "__VITE_ASSET__D2STvmzX__"